import React from "react";

export default function Form({ children, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className="w-full flex flex-col gap-8 ">
      {children}
    </form>
  );
}
